import { render, staticRenderFns } from "./BillingAddressModal.vue?vue&type=template&id=53e29f01"
import script from "./BillingAddressModal.vue?vue&type=script&lang=js"
export * from "./BillingAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports